<template>
  <b-input-group>
    <template #append>
      <span class="bg-gray-100 pt-2 px-2">
        <a tabindex="-1" href="javascript:void(0)" @click.prevent="toggleShowPassword()"><i :class="{'fs-2': true, 'bx bx-show': currentType === 'password', 'bx bx-hide': currentType === 'text'}" :style="{color: currentType === 'password' ? '#A09E9E': '#454646'}" aria-hidden="true"></i></a>
      </span>
    </template>
    <b-form-input
        v-bind="$attrs"
        :type="currentType"
        :value="value"
        :state="state"
        @input="onInput"
    />
  </b-input-group>
</template>

<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'input'
  },
  props: {
    value: [String, Number],
    state: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      currentType: 'password'
    }
  },
  methods: {
    toggleShowPassword(){
      if (this.currentType === 'password'){
        this.currentType = 'text'
      }else {
        this.currentType = 'password'
      }
    },
    onInput(event) {
      const value = event && event.target ? event.target.value : event;
      this.$emit('input',  value);
    }
  }
}
</script>
